import { render, staticRenderFns } from "./CallManagement.vue?vue&type=template&id=842019b0&scoped=true&"
import script from "./CallManagement.vue?vue&type=script&lang=js&"
export * from "./CallManagement.vue?vue&type=script&lang=js&"
import style0 from "./CallManagement.vue?vue&type=style&index=0&id=842019b0&prod&lang=scss&scoped=true&"
import style1 from "./CallManagement.vue?vue&type=style&index=1&id=842019b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842019b0",
  null
  
)

export default component.exports